// eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
window.global ||= window;

import { init } from "@sentry/react";

import { StrictMode } from "react";

import { createRoot } from "react-dom/client";

import { Provider } from "react-redux";
import { BrowserRouter } from "react-router-dom";

import { ChakraProvider } from "@chakra-ui/react";

import { ApiQueryErrorBoundary, UncaughtErrorBoundary } from "@components/error-boundary";

import { store } from "@state/store";

import { App } from "./App";
import { system } from "./theme";


const container = document.querySelector("#root") as HTMLElement;
const root = createRoot(container);

root.render(
  <StrictMode>
    <ChakraProvider value={system}>
      <Provider store={store}>
        <BrowserRouter
          // hide deprecation warnings
          future={{
            v7_startTransition: false,
            v7_relativeSplatPath: false,
          }}
        >
          <UncaughtErrorBoundary>
            <ApiQueryErrorBoundary>
              <App />
            </ApiQueryErrorBoundary>
          </UncaughtErrorBoundary>
        </BrowserRouter>
      </Provider>
    </ChakraProvider>
  </StrictMode>,
);
